import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../../../components/ConfirmModal';
import ProfileImage from '../../../components/ProfileImage';
import './IncomingFriendRequests.css';

const IncomingFriendRequests = ({ requests, onRespond }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [actionType, setActionType] = useState('');
    const navigate = useNavigate();

    const openModal = (user, type) => {
        setSelectedUser(user);
        setActionType(type);
        setModalOpen(true);
    };

    const handleConfirm = () => {
        if (selectedUser) {
            onRespond(selectedUser._id, actionType === 'accept');
        }
        setModalOpen(false);
    };

    return (
        <div className="section">
            <div className="list-container">
                {requests.length > 0 ? (
                    requests.map(user => (
                        <div key={user._id} className="friend-row">
                            <div
                                className="friend-avatar-clickable"
                                onClick={() => navigate(`/user/${user.username}`)}
                                title={`View ${user.username}'s profile`}
                            >
                                <ProfileImage
                                    src={user.profilePicture}
                                    alt="avatar"
                                    className="friend-avatar"
                                />
                            </div>

                            <div className="friend-info">
                                <strong>{user.nickname || user.username}</strong>
                                <p>Wants to connect with you</p>
                            </div>

                            <div className="friend-actions">
                                <button
                                    className="small-btn primary"
                                    onClick={() => openModal(user, 'accept')}
                                >
                                    Accept
                                </button>
                                <button
                                    className="small-btn danger"
                                    onClick={() => openModal(user, 'decline')}
                                >
                                    Decline
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="empty-message">No new requests</p>
                )}
            </div>

            <ConfirmModal
                isOpen={modalOpen}
                title={actionType === 'accept' ? 'Accept Request' : 'Decline Request'}
                message={
                    selectedUser
                        ? actionType === 'accept'
                            ? `Accept ${selectedUser.nickname || selectedUser.username}'s friend request?`
                            : `Are you sure you want to decline ${selectedUser.nickname || selectedUser.username}'s request?`
                        : ''
                }
                onCancel={() => setModalOpen(false)}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default IncomingFriendRequests;
